export const PAGES_UNDER_MAINTENANCE = ['/services'];
export const MAINTENANCE_PAGE = '/maintenance';
